import React, { useState } from "react";
import ManageTemplates from "../../../../components/ui/Settings/Medicines/manage-templates/index.jsx";
import { getAllTemplates } from "../../../../api/settings/Medicines/medicines.js";
import useDelayedSearch from "../../../../utils/delayedsearch.js";

export const MedTemplatesPage = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchKey, setSearchKey] = useState("");

  const getAllTemplatesData = () => {
    setLoading(true);
    getAllTemplates(searchKey)
      .then((response) => {
        setTemplates(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /** For delay in search hook */
  useDelayedSearch(getAllTemplatesData, 200, [searchKey]);

  return (
    <div>
      <ManageTemplates
        loading={loading}
        templates={templates}
        getAllTemplatesData={getAllTemplatesData}
        setSearchKey={setSearchKey}
        searchKey={searchKey}
      />
    </div>
  );
};
